import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", null, [
        _createElementVNode("g", null, [
          _createElementVNode("g", null, [
            _createElementVNode("path", {
              fill: "#D8D8D8",
              "fill-opacity": "0",
              d: "M0 0H16V16H0z",
              transform: "translate(-313 -744) translate(305 740) translate(8 4)"
            }),
            _createElementVNode("path", {
              fill: "#FFF",
              d: "M6.99.63L2.802 8.725c-.09.173-.136.365-.136.56 0 .658.517 1.191 1.155 1.191h2.837c.09 0 .165.076.165.17v4.164c0 .439.234.842.61 1.05.561.31 1.261.092 1.563-.487l4.2-8.079c.09-.173.136-.366.136-.562 0-.658-.517-1.19-1.155-1.19h-2.85c-.09 0-.165-.077-.165-.171V1.19c0-.439-.235-.843-.611-1.05C7.989-.17 7.29.05 6.989.63zm1.096.41c.054.03.087.088.087.15v4.18c0 .658.518 1.19 1.155 1.19h2.85c.092 0 .165.077.165.17 0 .029-.006.056-.02.081L8.125 14.89c-.043.082-.143.113-.223.07-.054-.03-.087-.088-.087-.15v-4.165c0-.657-.517-1.19-1.155-1.19H3.822c-.092 0-.165-.076-.165-.17 0-.028.006-.056.019-.08L7.863 1.11c.036-.07.111-.103.182-.086l.041.016z",
              transform: "translate(-313 -744) translate(305 740) translate(8 4)"
            })
          ])
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }